<div id="wrapper">
  <app-navbar></app-navbar>

  <app-sidebar [isCondensed]="isCondensed"></app-sidebar>
  <div class="content-page">
    <div class="content">
      <div class="dashboard-pane">
        <div class="container-fluid">
          <div class="breadcrumb">
            <span class="breadcrumb-item">
              <a href="javascript:void(0)">Home</a>
            </span>
            <span class="px-2"><i class="ri-arrow-right-s-line"></i></span>
            <span class="breadcrumb-item" aria-current="page">
              <a routerLink="/dashboard">Dashboard</a>
            </span>
          </div>
          <div class="row negative-margin">
            <div class="col-md-12">
              <div *ngIf="sessionExpired" class="alert alert-danger session-text text-center" role="alert">
                {{ errorMsg }}
                <span class="relogin" (click)="accountLogout()">Click here to LogIn</span>
              </div>

              <ng-container *ngIf="onboardingStatus">
                <div class="alert alert-success session-text text-center" role="alert">
                  <p *ngIf="passwordSet">{{ pwChangeMsg }}</p>
                  <p *ngIf="onboadingSet">
                    {{ onboardingSucessMsg }}
                  </p>
                </div>
              </ng-container>

              <ng-container *ngIf="loading">
                <div class="text-center loader-spacer-10">
                  <app-loader></app-loader>
                </div>
              </ng-container>

              <ng-container *ngIf="!loading">
                <div class="stats-wrapper">
                  <div class="charts-wrapper">
                    <div class="row">
                      <p class="refresh py-1 px-2">
                        <i (click)="refreshInternalStats()" class="ri-refresh-line"> </i>
                      </p>
                      <div class="col-md-6">
                        <div class="card">
                          <div class="pane-header">
                            <div class="row">
                              <div class="col-12">
                                <h5 class="py-3 px-2">Overview of Invoices Submitted</h5>
                              </div>
                            </div>
                          </div>
                          <div class="card-body text-center">
                            <ng-container *ngIf="refreshInternalAnalytics">
                              <app-loader></app-loader>
                            </ng-container>

                            <ng-container *ngIf="!refreshInternalAnalytics">
                              <div class="empty-state" *ngIf="!chartDataInvoice">
                                <img src="assets/images/empty-state.png" alt="No-data" />
                                <h6 class="card-title my-2">No Data Available</h6>
                                <p class="card-text">There is no available data to show.</p>
                              </div>
                              <div class="empty-state" *ngIf="internalError">
                                <img src="assets/images/empty-state.png" alt="No-data" />
                                <h6 class="card-title my-2">Request terminated, refresh to connect.</h6>
                              </div>
                              <div class="chart-container" *ngIf="chartDataInvoice">
                                <div class="row">
                                  <div class="col-8">
                                    <apx-chart
                                      [series]="chartOptions.series"
                                      [chart]="chartOptions.chart"
                                      [xaxis]="chartOptions.xaxis"
                                      [colors]="chartOptions.colors"
                                      [plotOptions]="chartOptions.plotOptions"
                                      [tooltip]="chartOptions.tooltip"
                                    ></apx-chart>
                                  </div>
                                  <div class="col-4">
                                    <div class="stats-pane py-5">
                                      <p class="stats-text">
                                        {{ this.statsInternal.number_invoices.number | number }}
                                      </p>
                                      <p class="stats-desc">Total Submitted Invoices</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="card">
                          <div class="pane-header">
                            <div class="row">
                              <div class="col-12">
                                <h5 class="py-3 px-3">Overview of Purchase Orders</h5>
                              </div>
                            </div>
                          </div>
                          <div class="card-body text-center">
                            <ng-container *ngIf="refreshInternalAnalytics">
                              <app-loader></app-loader>
                            </ng-container>

                            <ng-container *ngIf="!refreshInternalAnalytics">
                              <div class="empty-state" *ngIf="!chartDataPo">
                                <img src="assets/images/empty-state.png" alt="No-data" />
                                <h6 class="card-title my-2">No Data Available</h6>
                                <p class="card-text">There is no available data to show.</p>
                              </div>
                              <div class="empty-state" *ngIf="internalError">
                                <img src="assets/images/empty-state.png" alt="No-data" />
                                <h6 class="card-title my-2">Request terminated, refresh to connect.</h6>
                              </div>
                              <div class="chart-container" *ngIf="chartDataPo">
                                <div class="row">
                                  <div class="col-8">
                                    <apx-chart
                                      [series]="donutChartOptions.series"
                                      [chart]="donutChartOptions.chart"
                                      [dataLabels]="donutChartOptions.dataLabels"
                                      [legend]="donutChartOptions.legend"
                                      [labels]="donutChartOptions.labels"
                                      [colors]="donutChartOptions.colors"
                                      [xaxis]="donutChartOptions.xaxis"
                                      [tooltip]="donutChartOptions.tooltip"
                                    ></apx-chart>
                                  </div>
                                  <div class="col-4">
                                    <div class="stats-pane py-5">
                                      <p class="stats-text">
                                        {{ statsInternalPo.total_po_number }}
                                      </p>
                                      <p class="stats-desc">Total No. of POs</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="grn-data">
                    <ng-container *ngIf="isError">
                      <div class="alert alert-danger session-text text-center" role="alert">Your Request has timed out. Request to external JSW server could not be completed, please try again.</div>
                    </ng-container>
                    <div class="row">
                      <p class="refresh py-1 px-2">
                        <i (click)="refreshExternalStats()" class="ri-refresh-line"> </i>
                      </p>

                      <ng-container *ngIf="refreshAnalytics">
                        <div class="text-center">
                          <app-loader></app-loader>
                        </div>
                      </ng-container>

                      <ng-container *ngIf="!refreshAnalytics">
                        <div class="empty-state text-center" *ngIf="externalError">
                          <img src="assets/images/empty-state.png" alt="No-data" />
                          <h6 class="card-title my-2">Request terminated, refresh to connect.</h6>
                        </div>

                        <ng-container *ngIf="!externalError">
                          <div class="col-md-4">
                            <div class="card">
                              <p class="stats-header">Total Outstanding Amount</p>
                              <p class="stats-text" *ngIf="stats?.Payment_Due_Amount !== null && stats?.Payment_Due_Amount !== '' && stats?.Payment_Due_Amount !== 'NA'">
                                INR
                                {{ stats?.Payment_Due_Amount | inrdisplay }}
                              </p>
                              <p class="stats-text" *ngIf="stats?.Payment_Due_Amount === null || stats?.Payment_Due_Amount === ''">INR 0.00</p>
                              <p class="stats-text" *ngIf="stats?.Payment_Due_Amount === 'NA'">NA</p>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card">
                              <p class="stats-header">Retention Amount</p>
                              <p class="stats-text" *ngIf="stats?.Retention !== null && stats?.Retention !== 'NA'">
                                INR
                                {{ stats?.Retention | inrdisplay }}
                              </p>
                              <p class="stats-text" *ngIf="stats?.Retention === null">INR 0.00</p>
                              <p class="stats-text" *ngIf="stats?.Retention === 'NA'">NA</p>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card">
                              <p class="stats-header">LD Amount</p>
                              <p class="stats-text" *ngIf="stats?.LD_Amount !== null && stats?.LD_Amount !== 'NA'">
                                INR
                                {{ stats?.LD_Amount | inrdisplay }}
                              </p>
                              <p class="stats-text" *ngIf="stats?.LD_Amount === null">INR 0.00</p>
                              <p class="stats-text" *ngIf="stats?.LD_Amount === 'NA'">NA</p>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card">
                              <p class="stats-header">Advances</p>
                              <p class="stats-text" *ngIf="stats?.Advances !== null && stats?.Advances !== 'NA'">
                                INR
                                {{ stats?.Advances | inrdisplay }}
                              </p>
                              <p class="stats-text" *ngIf="stats?.Advances === null">INR 0.00</p>
                              <p class="stats-text" *ngIf="stats?.Advances === 'NA'">NA</p>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card">
                              <p class="stats-header">GST Unreconciled No. of Invoices</p>
                              <p class="stats-text" *ngIf="stats?.GST_unreconciled_No_of_invoices !== null && stats?.GST_unreconciled_No_of_invoices !== 'NA'">
                                {{ stats?.GST_unreconciled_No_of_invoices | number }}
                              </p>
                              <p class="stats-text" *ngIf="stats?.GST_unreconciled_No_of_invoices === null">INR 0.00</p>
                              <p class="stats-text" *ngIf="stats?.GST_unreconciled_No_of_invoices === 'NA'">NA</p>
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="card">
                              <p class="stats-header">GST Unreconciled Amount</p>
                              <p class="stats-text" *ngIf="stats?.GST_unreconciled_Amount !== null && stats?.GST_unreconciled_Amount !== 'NA'">
                                INR
                                {{ stats?.GST_unreconciled_Amount | inrdisplay }}
                              </p>
                              <p class="stats-text" *ngIf="stats?.GST_unreconciled_Amount === null">INR 0.00</p>
                              <p class="stats-text" *ngIf="stats?.GST_unreconciled_Amount === 'NA'">NA</p>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
